module.exports = __webpack_public_path__ + "assets/img/1_1539.e1ef4a25.jpg";